$(document).ready(function() {
    $("#bannerslider").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        navText: ["<span><i class='fa fa-angle-right'></i></span>", "<span><i class='fa fa-angle-left'></i></span>"]
    });

    


    $("#product-slider").owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        dots: true,

        autoplay: true,
        autoplayTimeout: 4000,
        autoplaySpeed: 1000,
        smartSpeed: 1000,
        autoplayHoverPause: false,

        mouseDrag: true,
        touchDrag: true,

        animateIn: "fadeIn",
        animateOut: "fadeOut",
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin:0
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });





	

    $("#team-slid").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true,
                margin: 20
            },
            600: {
                items: 2,
                nav: false,
                margin: 20
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });



	 $("#related-slid").owlCarousel({
        items: 2,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true,
                margin: 20,
            },
            600: {
                items: 2,
                nav: false,
                margin: 20,
            },


            1000: {
                items:2,
                nav: false,
                loop: true,
                margin: 26,
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]




    });






});







$(document).ready(function() {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('.up').fadeIn(400);
        } else { $('.up').fadeOut(400); }
    });

    $('.up').click(function(event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 800);
    });

});


const header = document.querySelector(".page-header");
const toggleClass = "is-sticky";

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll > 150) {
    header.classList.add(toggleClass);
  } else {
    header.classList.remove(toggleClass);
  }
});













 jQuery(window).scroll(function() {
     var scroll = jQuery(window).scrollTop();
    if (scroll >= 100) {
        jQuery('header').addClass('fixed-nav');
     } else {
        jQuery('header').removeClass('fixed-nav');
    }
 });

$(function() {
    var $gallery = $('.gallery a').simpleLightbox();

    $gallery.on('show.simplelightbox', function() {
            console.log('Requested for showing');
        })
        .on('shown.simplelightbox', function() {
            console.log('Shown');
        })
        .on('close.simplelightbox', function() {
            console.log('Requested for closing');
        })
        .on('closed.simplelightbox', function() {
            console.log('Closed');
        })
        .on('change.simplelightbox', function() {
            console.log('Requested for change');
        })
        .on('next.simplelightbox', function() {
            console.log('Requested for next');
        })
        .on('prev.simplelightbox', function() {
            console.log('Requested for prev');
        })
        .on('nextImageLoaded.simplelightbox', function() {
            console.log('Next image loaded');
        })
        .on('prevImageLoaded.simplelightbox', function() {
            console.log('Prev image loaded');
        })
        .on('changed.simplelightbox', function() {
            console.log('Image changed');
        })
        .on('nextDone.simplelightbox', function() {
            console.log('Image changed to next');
        })
        .on('prevDone.simplelightbox', function() {
            console.log('Image changed to prev');
        })
        .on('error.simplelightbox', function(e) {
            console.log('No image found, go to the next/prev');
            console.log(e);
        });
});





$(function() {
    var $gallery = $('.gallery1 a').simpleLightbox();
   
});

$(function() {
    var $gallery = $('.gallery2 a').simpleLightbox();
   
});

$(function() {
    var $gallery = $('.gallery3 a').simpleLightbox();
   
});

$(function() {
    var $gallery = $('.gallery4 a').simpleLightbox();
   
});


